import React from 'react';
import HtmlEditor from '../HtmlEditor';
import { ReportData } from '../../types/report.types';

interface MethodologyEditorProps {
  reportData: ReportData;
  onHtmlChange: (field: keyof ReportData, value: string) => void;
}

const MethodologyEditor: React.FC<MethodologyEditorProps> = ({ reportData, onHtmlChange }) => {
  return (
    <div className="space-y-8">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">Methodology</h3>
          <p className="text-sm text-gray-600 mt-1">Edit the methodology content below</p>
        </div>
        <div className="p-6">
          <HtmlEditor
            field="methodology"
            title="Methodology"
            reportData={reportData}
            onHtmlChange={onHtmlChange}
          />
        </div>
      </div>
    </div>
  );
};

export default MethodologyEditor; 